import axios from 'axios';
import { getAccessToken } from './auth/tokenManager';
import { DEMO_USER_HEADER_NAME, getDemoUserRequestHeaderValue } from './utils/demoUser';

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});


instance.interceptors.request.use(async (config) => {
  try {
    const url = config.url || '';
    const isAbsolute = /^https?:\/\//i.test(url);
    const baseUrl = instance.defaults.baseURL || '';
    const hasAuthorizationHeader = Boolean(
      config.headers?.Authorization || config.headers?.authorization
    );

    // Attach token for relative URLs (handled by this instance) or absolute URLs that target our base API
    const shouldAttach = !isAbsolute || (baseUrl && url.startsWith(baseUrl));

    if (shouldAttach && !hasAuthorizationHeader) {
      const token = await getAccessToken();
      if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
      }
    }

    const demoUserEmail = getDemoUserRequestHeaderValue();
    if (demoUserEmail) {
      config.headers = config.headers || {};
      config.headers[DEMO_USER_HEADER_NAME] = demoUserEmail;
    }
  } catch (e) {
    console.error('Failed to attach auth token', e);
  }
  return config;
});

export default instance;
